import http from '../http';

const login = {
    /**
     * 获取地区
     */
    areas() {
        return http.get(`/api/1.0/Area/GetList`);
    },

    loginData(model) {
        return http.post(`/auth_resource/login`, model);
    },

    getLoginInfo() {
        return http.get(`/auth_resource/loginInfo`);
    },

    getTokenByWorkWxCode(code){
        return http.get(`/auth_resource/qw/token?code=${code}`);
    },
    getRedirectUrl(url){
        return http.get(`/auth_resource/qw/url?url=${url}`)
    }
}
export default login;
